/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { getThemeCookie, resolveVuetifyTheme } from '@/utils/vuetify.ts'
import { staticPrimaryColor, staticPrimaryDarkenColor, themes } from '@/plugins/vuetify/theme.ts'
import themeConfig from '@/plugins/vuetify/themeConfig.ts'
import type { LocaleOptions, RtlOptions } from 'vuetify/framework'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { getI18n } from '@/plugins/i18n.ts'
import { VRadio } from 'vuetify/components'
import radioBoxMarded from '@/assets/icons/radiobox-marked.svg'
import radioBoxBlank from '@/assets/icons/radiobox-blank.svg'

const themeOptions = {
  defaultTheme: resolveVuetifyTheme(themeConfig.app.theme),
  themes: {
    light: {
      colors: {
        'primary': getThemeCookie('lightThemePrimaryColor', staticPrimaryColor),
        'primary-darken-1': getThemeCookie('lightThemePrimaryDarkenColor', staticPrimaryDarkenColor),
      },
    },
    dark: {
      colors: {
        'primary': getThemeCookie('darkThemePrimaryColor', staticPrimaryColor),
        'primary-darken-1': getThemeCookie('darkThemePrimaryDarkenColor', staticPrimaryDarkenColor),
      },
    },
    ...themes,
  },
}

const localOptions: LocaleOptions & RtlOptions = {
  adapter: createVueI18nAdapter({ i18n: getI18n(), useI18n }),
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: themeOptions,
  locale: localOptions,
  components: {
    VDateInput,
  },
  aliases: {
    AppRadio: VRadio,
  },
  defaults: {
    AppRadio: {
      falseIcon: markRaw(radioBoxBlank as unknown as object),
      trueIcon: markRaw(radioBoxMarded as unknown as object),
    },
  },
})
